module.exports = __webpack_public_path__ + "static/media/nima_with_flower.688a618b.png";